import { userInfoSync } from 'hub-http/userInfo';
import { UserAttributesClient } from 'frontend-preferences-client';
import * as storage from 'EmailData/lib/storage';
import { LOCAL_STORAGE_BASE_KEY, USER_ATTRIBUTES_CACHE_KEY } from 'EmailEditorUI/constants/LocalStorageConstants';
const userAttributesClientForEmailEditor = UserAttributesClient.forCaller('EmailDragDropEditorUI');
const userAttributesClientForTemplateEditor = UserAttributesClient.forCaller('EmailTemplateEditorUI');
/** Uncached, require a fresh response from /user-attributes  */
const LAZY_ATTRIBUTES = {};
function rewriteLazyAtributes(source) {
  return Object.keys(source).reduce((acc, cur) => {
    if (LAZY_ATTRIBUTES[cur]) {
      acc[cur] = LAZY_ATTRIBUTES[cur];
    }
    return acc;
  }, source);
}
export function setUserAttributeRequest({
  attribute,
  value,
  isTemplateEditor = false
}) {
  const userAttributesClientName = isTemplateEditor ? userAttributesClientForTemplateEditor : userAttributesClientForEmailEditor;
  return userAttributesClientName.write(attribute, String(value)).catch(err => {
    throw err;
  });
}
export const getStoredAttributesInLocalStorage = () => {
  const {
    user,
    portal
  } = userInfoSync();
  return storage.get(portal.portal_id, LOCAL_STORAGE_BASE_KEY, USER_ATTRIBUTES_CACHE_KEY(`${user.user_id}`));
};
export async function batchFetchUserAttributes({
  keys,
  isTemplateEditor = false
}) {
  const userAttributesClientName = isTemplateEditor ? userAttributesClientForTemplateEditor : userAttributesClientForEmailEditor;
  const attributesInLocalStorage = getStoredAttributesInLocalStorage();
  const defaults = keys.reduce((acc, key) => {
    const value = attributesInLocalStorage && !!attributesInLocalStorage[key] ? attributesInLocalStorage[key] : '';
    acc[key] = value;
    return acc;
  }, {});
  const result = await userAttributesClientName.batchFetch(defaults);
  if (result === defaults) {
    return rewriteLazyAtributes(result);
  }
  return result;
}